import { render, staticRenderFns } from "./FpsControls.vue?vue&type=template&id=4db0c902&scoped=true&"
import script from "./FpsControls.vue?vue&type=script&lang=js&"
export * from "./FpsControls.vue?vue&type=script&lang=js&"
import style0 from "./FpsControls.vue?vue&type=style&index=0&id=4db0c902&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db0c902",
  null
  
)

export default component.exports